import { cva } from 'class-variance-authority'

const badgeVariants = cva(
  'inline-flex items-center rounded-radius-sm border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-primary text-primary-foreground shadow hover:bg-primary/80',
        secondary:
          'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
        destructive:
          'border-transparent bg-destructive text-destructive-foreground shadow hover:bg-destructive/80',
        outline: 'text-foreground',
        'danger-dim-light':
          'border-transparent bg-danger-dim-light text-danger-foreground hover:bg-danger-dim-light/80',
        'success-dim-light':
          'border-transparent bg-success-dim-light text-success-forground hover:bg-success-dim-light/80',
        'warning-dim-light':
          'border-transparent bg-warning-dim-light text-warning-foreground hover:bg-warning-dim-light/80',
        'info-dim-light':
          'border-transparent bg-info-dim-light text-info-forground hover:bg-info-dim-light/80',
        'hold-dim-light':
          'border-transparent bg-hold-dim-light text-hold-foreground hover:bg-hold-dim-light/80',
        'transfer-dim-light':
          'border-transparent bg-transfer-dim-light text-transfer-foreground hover:bg-transfer-dim-light/80',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export { badgeVariants }
